import { ConvertToRestDayModal } from '@client/new/pages/workout/components/ConvertToRestDayModal/ConvertToRestDayModal';
import { ConvertToRestDayToast } from '@client/new/pages/workout/components/ConvertToRestDayModal/ConvertToRestDayToast';
import { Button } from '@design-system/components/button/button';
import { SearchInput } from '@design-system/components/searchinput';
import { SmartTable } from '@client/new/components/SmartTable/SmartTable';
import { DuplicateWorkoutDialog } from '@client/new/features/workout-duplicate';
import { useDraftWorkouts } from './components/useDraftWorkouts';
import { WorkoutsPage } from './components/WorkoutsPage';
import * as styles from './components/workoutsListPage.css';

export function DraftWorkoutsPage(props) {
  const {
    isLoading,
    creator,
    isEmpty,
    table,
    search,
    pagination,
    convertToRestDay,
    duplicateDialog,
  } = useDraftWorkouts(props.params.influencerId);

  return (
    <WorkoutsPage isLoading={isLoading} creator={creator}>
      <ConvertToRestDayModal
        isOpen={convertToRestDay.isOpen}
        workoutTitle={convertToRestDay.workoutTitle}
        onCancel={convertToRestDay.cancel}
        onConfirm={convertToRestDay.confirm}
      />
      {convertToRestDay.outcome ? (
        <ConvertToRestDayToast
          outcome={convertToRestDay.outcome}
          onShown={convertToRestDay.clearOutcome}
        />
      ) : null}
      {!isEmpty && (
        <div className={styles.search}>
          <SearchInput
            value={search.value}
            placeholder="Search workout"
            onChange={(e) => search.onChange(e.target.value)}
            onClear={search.onClear}
          />
        </div>
      )}
      <div className={styles.listSection}>
        {isEmpty ? 'This list is empty' : <SmartTable {...table} />}
      </div>
      {(pagination.hasPrevPage || pagination.hasNextPage) && (
        <div className={styles.pagination}>
          <Button
            variant="outlined"
            disabled={!pagination.hasPrevPage}
            onClick={pagination.goPrev}
          >
            Previous
          </Button>
          <Button
            variant="outlined"
            disabled={!pagination.hasNextPage}
            onClick={pagination.goNext}
          >
            Next
          </Button>
        </div>
      )}
      {duplicateDialog ? <DuplicateWorkoutDialog {...duplicateDialog} /> : null}
    </WorkoutsPage>
  );
}
